/* eslint-disable func-names */
import tmsMdmAxiosInstance from '@/tms-mdm-axios';

export const getActiveTransporters = async function () {
  try {
    return await tmsMdmAxiosInstance.get('/transporter/active');
  } catch (error) {
    throw error;
  }
};
